package songwritersnotebook.database

import kotlin.Long
import kotlin.String

public data class SongEntity(
  public val id: String,
  public val ownerId: String,
  public val title: String,
  public val lastModified: Long,
  public val bpm: Long,
  public val isDeleted: Long,
  public val data_: String,
)
